module.exports = __webpack_public_path__ + "static/media/ios-backspace.3e8ce21a.svg";